import { isValid, parseISO } from 'date-fns'
import type { WorkPostSheetFormValues } from '../providers/FormProvider'
import { AiSuggestedWorkPostSheet, WorkPostSheetItemTypesEnum } from '../types'
import { isDateWPSItem } from './isDateWPSItem'
import { isMaternityProtectionMeasuresWPSItem } from './isMaternityProtectionMeasuresWPSItem'

export const aiSuggestedWpsToWPSFormValues = (
  aiSuggestedWorkPostSheet: AiSuggestedWorkPostSheet
): Partial<WorkPostSheetFormValues> => {
  const suggestedItems = aiSuggestedWorkPostSheet.items.filter(
    item =>
      item.name !== WorkPostSheetItemTypesEnum.PDF_URL &&
      Object.values(WorkPostSheetItemTypesEnum).includes(
        item.name as WorkPostSheetItemTypesEnum
      )
  )

  const maternityProtectionMeasuresRequired = suggestedItems.some(
    item =>
      isMaternityProtectionMeasuresWPSItem(
        item.name as WorkPostSheetItemTypesEnum
      ) && !!item.comment
  )

  return {
    tasksToPerform: aiSuggestedWorkPostSheet.tasksToPerform || '',
    requiredQualifications:
      aiSuggestedWorkPostSheet.requiredQualifications || '',
    workEquipment: aiSuggestedWorkPostSheet.workEquipment || '',
    priorInstructions: aiSuggestedWorkPostSheet.priorInstructions || '',
    foreseeableTraining: aiSuggestedWorkPostSheet.foreseeableTraining || '',
    workstationLocation: aiSuggestedWorkPostSheet.workstationLocation || '',
    maternityProtectionMeasuresRequired,
    items: Object.values(WorkPostSheetItemTypesEnum).map(name => {
      const suggestedItem = suggestedItems.find(item => item.name === name)

      let comment: string | Date = suggestedItem?.comment || ''
      if (isDateWPSItem(name) && comment) {
        const date = parseISO(comment)
        // drop unparsable AI dates, formatting an invalid date on submit would throw
        comment = isValid(date) ? date : ''
      }

      return {
        name,
        comment,
        checked: !!suggestedItem
      }
    })
  }
}
